import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Pricing from "./components/Pricing";
import WhyUs from "./components/WhyUs";
import Clients from "./components/Clients";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ServiceDetailPage from "./components/ServiceDetailPage";
import Influencer from "./components/Influencer";
import Influencervideo from "./components/Influencervideo";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsConditions from "./components/TermsConditions";
import StatsCounter from "./components/StatsCounter";

// ✅ TEMP Detail Page (You can style it later)


export default function App() {
  return (
    <Router>
      <Navbar />

      <main>
        <Routes>
          {/* ✅ Home Page Route */}
          <Route
            path=""
            element={
              <>
                <Hero />
                <About />
                <WhyUs />
                <Pricing />
                <Clients />
                <StatsCounter/>
                <Contact />
                {/* <ContactCard/ > */}
              </>
            }
          />

          {/* ✅ CLICK → Opens this dynamic page */}
          <Route path="/finacialservice/:finacialserviceId" element={<Influencer />} />
          <Route path="/service/:serviceId" element={<ServiceDetailPage />} />
          <Route path="/Influencer" element={<Influencervideo />} />
          <Route path="/Financial" element={<ServiceDetailPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/termconditions" element={<TermsConditions />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}
